import { ERA_LOOKS } from '@continuum/show-core';
import type { TaskDef } from '@continuum/show-core';
import { Screen } from '../../ui/Shell.js';
import { Eyebrow, Lede, Spacer } from '../../ui/atoms.js';
import { TaskQueue } from '../../ui/TaskQueue.js';
import type { QueueRow } from '../../ui/TaskQueue.js';
import type { ScreenCopy } from '../../ui/screenText.js';

/**
 * Era 5 — back on the surface. Ordinary games like every other stop (Marek, 2026-09-29: the
 * message for the next evening's guests is gone): a line about where we are, a few shoots coming
 * up at dawn, and the list.
 */
export function Surface({
  rows,
  s,
  title,
  onOpen,
}: {
  rows: QueueRow[];
  s: ScreenCopy;
  title: (def: TaskDef) => string;
  onOpen: (row: QueueRow) => void;
}) {
  const look = ERA_LOOKS[5];

  return (
    <Screen style={{ background: 'linear-gradient(180deg,#eae4d0,#e4dec9)', color: '#2c3527', padding: 24 }}>
      <Eyebrow color={look.acc}>{s.era5Eyebrow}</Eyebrow>
      <h1 style={{ margin: '12px 0 6px', fontSize: 24, fontWeight: 700, letterSpacing: 2 }}>{s.era5Title}</h1>
      <Lede color="#4f5c46">{s.era5Lede}</Lede>

      {/* Five shoots in a row of soil, swaying slowly: the garden the stop is about. */}
      <svg viewBox="0 0 200 60" style={{ display: 'block', width: '100%', maxWidth: 320, margin: '18px auto 0' }} aria-hidden="true">
        <path d="M4 52 Q100 44 196 52" stroke="rgba(92,125,78,.55)" strokeWidth="2" fill="none" />
        {[24, 62, 100, 138, 176].map((x, i) => (
          <g key={x} style={{ transformOrigin: `${x}px 50px`, animation: `ccSway ${5 + i * 0.7}s ease-in-out ${i * 0.4}s infinite` }}>
            <path d={`M${x} 50 Q${x - 2} 36 ${x} ${26 + (i % 2) * 6}`} stroke={look.acc} strokeWidth="2" fill="none" />
            <path d={`M${x} ${38 + (i % 2) * 3} q-9 -4 -12 -12 q9 1 12 12`} fill={look.acc} opacity=".8" />
            <path d={`M${x} ${33 + (i % 2) * 5} q9 -4 12 -12 q-9 1 -12 12`} fill={look.acc} opacity=".65" />
          </g>
        ))}
      </svg>

      <TaskQueue rows={rows} look={look} s={s} title={title} onOpen={onOpen} />
      <Spacer min={12} />
    </Screen>
  );
}
